export const FETCH_PATIENT_VISITS = "[RECEPTIONIST] FETCH_PATIENT_VISITS";
export const FETCH_PATIENT_VISITS_START = "[RECEPTIONIST] FETCH_PATIENT_VISITS_START";
export const FETCH_PATIENT_VISITS_SUCCESS = "[RECEPTIONIST] FETCH_PATIENT_VISITS_SUCCESS";
export const FETCH_PATIENT_VISITS_ERROR = "[RECEPTIONIST] FETCH_PATIENT_VISITS_ERROR";

export const ADD_UPDATE_VISIT = "[RECEPTIONIST] ADD_UPDATE_VISIT";
export const ADD_UPDATE_VISIT_START = "[RECEPTIONIST] ADD_UPDATE_VISIT_START";
export const ADD_UPDATE_VISIT_SUCCESS = "[RECEPTIONIST] ADD_UPDATE_VISIT_SUCCESS";
export const ADD_UPDATE_VISIT_ERROR = "[RECEPTIONIST] ADD_UPDATE_VISIT_ERROR";

export const DELETE_PATIENT_EXAMINATION = "[RECEPTIONIST] DELETE_PATIENT_EXAMINATION";
export const DELETE_PATIENT_EXAMINATION_SUCCESS = "[RECEPTIONIST] DELETE_PATIENT_EXAMINATION_SUCCESS";
export const DELETE_PATIENT_EXAMINATION_ERROR = "[RECEPTIONIST] DELETE_PATIENT_EXAMINATION_ERROR";

export const DELETE_QUICK_CODES_EXAMINATION = "[RECEPTIONIST] DELETE_QUICK_CODES_EXAMINATION";
export const DELETE_QUICK_CODES_EXAMINATION_SUCCESS = "[RECEPTIONIST] DELETE_QUICK_CODES_EXAMINATION_SUCCESS";
export const DELETE_QUICK_CODES_EXAMINATION_ERROR = "[RECEPTIONIST] DELETE_QUICK_CODES_EXAMINATION_ERROR";

export const RESET_PATIENT_VISITS = "[RECEPTIONIST] RESET_PATIENT_VISITS";

export const UPLOAD_VISIT_DOCUMENT = "[RECEPTIONIST] UPLOAD_VISIT_DOCUMENT";
export const UPLOAD_VISIT_DOCUMENT_SUCCESS = "[RECEPTIONIST] UPLOAD_VISIT_DOCUMENT_SUCCESS";
export const UPLOAD_VISIT_DOCUMENT_ERROR = "[RECEPTIONIST] UPLOAD_VISIT_DOCUMENT_ERROR";

export const DELETE_VISIT_DOCUMENT = "[RECEPTIONIST] DELETE_VISIT_DOCUMENT";
export const DELETE_VISIT_DOCUMENT_SUCCESS = "[RECEPTIONIST] DELETE_VISIT_DOCUMENT_SUCCESS";
export const DELETE_VISIT_DOCUMENT_ERROR = "[RECEPTIONIST] DELETE_VISIT_DOCUMENT_ERROR";

export const CREATE_HL7_MESSAGE = "[RECEPTIONIST] CREATE_HL7_MESSAGE";
export const CREATE_HL7_MESSAGE_SUCCESS = "[RECEPTIONIST] CREATE_HL7_MESSAGE_SUCCESS";
export const CREATE_HL7_MESSAGE_ERROR = "[RECEPTIONIST] CREATE_HL7_MESSAGE_ERROR";

export const FETCH_VISIT_INVOICES = "[RECEPTIONIST] FETCH_VISIT_INVOICES";
export const FETCH_VISIT_INVOICES_START = "[RECEPTIONIST] FETCH_VISIT_INVOICES_START"
export const FETCH_VISIT_INVOICES_SUCCESS = "[RECEPTIONIST] FETCH_VISIT_INVOICES_SUCCESS";
export const FETCH_VISIT_INVOICES_ERROR = "[RECEPTIONIST] FETCH_VISIT_INVOICES_ERROR";

export const FETCH_VISIT_AUDIT = "FETCH_VISIT_AUDIT";
export const FETCH_VISIT_AUDIT_START = "FETCH_VISIT_AUDIT_START"
export const FETCH_VISIT_AUDIT_SUCCESS = "FETCH_VISIT_AUDIT_SUCCESS";
export const FETCH_VISIT_AUDIT_ERROR = "FETCH_VISIT_AUDIT_ERROR";

export const FETCH_APPOINTMENT_NOTES = "FETCH_APPOINTMENT_NOTES";
export const FETCH_APPOINTMENT_NOTES_START = "FETCH_APPOINTMENT_NOTES_START"
export const FETCH_APPOINTMENT_NOTES_SUCCESS = "FETCH_APPOINTMENT_NOTES_SUCCESS";
export const FETCH_APPOINTMENT_NOTES_ERROR = "FETCH_APPOINTMENT_NOTES_ERROR";

export const CLOSE_INVOICE_MODAL = "[RECEPTIONIST] CLOSE_INVOICE_MODAL";

export const FETCH_INVOICE_RECEIPTS = "[RECEPTIONIST] FETCH_INVOICE_RECEIPTS";
export const FETCH_INVOICE_RECEIPT_START = "[RECEPTIONIST] FETCH_INVOICE_RECEIPTS_START"
export const FETCH_INVOICE_RECEIPTS_SUCCESS = "[RECEPTIONIST] FETCH_INVOICE_RECEIPTS_SUCCESS";
export const FETCH_INVOICE_RECEIPTS_ERROR = "[RECEPTIONIST] FETCH_INVOICE_RECEIPTS_ERROR";

export const fetchPatientVisits = (patientId) => {
    return {
        type: FETCH_PATIENT_VISITS,
        payload: { patientId }
    }
}

export const addUpdateVisit = (visit) => {
    return {
        type: ADD_UPDATE_VISIT,
        payload: { visit }
    }
}

export const deletePatientExamination = (examinationId, visitId) => {
    return {
        type: DELETE_PATIENT_EXAMINATION,
        payload: { examinationId, visitId }
    }
}

export const deleteQuickCodeExamination = (quickCodeItemId, quickCodeId) => {
    return {
        type: DELETE_QUICK_CODES_EXAMINATION,
        payload: { quickCodeItemId, quickCodeId }
    }
}

export const resetPatientVisit = () => {
    return {
        type: RESET_PATIENT_VISITS,
        visits: []
    }
}

export const uploadVisitDocument = (document) => {
    return {
        type: UPLOAD_VISIT_DOCUMENT,
        payload: { document }
    }
}

export const deleteVisitDocument = (documentId, visitNo, resolve) => {
    return {
        type: DELETE_VISIT_DOCUMENT,
        payload: { documentId, visitNo, resolve }
    }
}

export const createHL7Message = (visit) => {
    return {
        type: CREATE_HL7_MESSAGE,
        payload: { visit }
    }
}

export const fetchVisitInvoices = (orderNo) => {
    return {
        type: FETCH_VISIT_INVOICES,
        payload: orderNo
    }
}

export const fetchVisitAuditInfo = (orderNo) => {
    return {
        type:FETCH_VISIT_AUDIT,
        payload:orderNo
    }
}

export const fetchAppointmentNotes = (appointmentId) => {

    //console.log('checkActionParam', appointmentId)
    return {
        type:FETCH_APPOINTMENT_NOTES,
        payload:appointmentId
    }
}

export const handleCloseInvoice = () => {
    return {
        type: CLOSE_INVOICE_MODAL
    }
}

export const fetchInvoiceReceipt = (invoiceId) => {
    return {
        type: FETCH_INVOICE_RECEIPTS,
        payload: invoiceId
    }
}